import type { NexusEvent } from "../../domain/mesh";
import type { PresentedNode } from "../../presentation/mesh";

const kindMass = {
  system: 1,
  entity: 0.62,
  artifact: 0.52,
  location: 0.58,
  goal: 0.64,
} as const;

export class AttentionField {
  private readonly hotIds = new Set<string>();
  private heat = 0;

  signal(event: NexusEvent | null) {
    this.hotIds.clear();
    this.heat = event ? 1 : 0;
    if (!event) return;
    this.hotIds.add(event.sourceNodeId);
    if (event.targetNodeId) this.hotIds.add(event.targetNodeId);
  }

  update(delta: number) {
    this.heat *= Math.exp(-delta * 0.42);
  }
  clear() {
    this.hotIds.clear();
    this.heat = 0;
  }

  weight(node: PresentedNode, selected: boolean, hovered: boolean, related: boolean) {
    let weight = kindMass[node.kind];
    if (node.status === "warning") weight += 0.22;
    else if (node.status === "active" || node.status === "building") weight += 0.1;
    else if (node.status === "draft") weight -= 0.08;
    if (node.metrics?.progress !== undefined) weight += Math.min(node.metrics.progress / 100, 1) * 0.08;
    if (related) weight += 0.08;
    if (hovered) weight += 0.14;
    if (selected) weight += 0.34;
    if (this.hotIds.has(node.id)) weight += this.heat * 0.24;
    return Math.max(0.34, Math.min(weight, 1.58));
  }

  glowOpacity(node: PresentedNode, weight: number) {
    const base = node.kind === "system" ? 0.15 : node.kind === "artifact" ? 0.07 : 0.1;
    return Math.min(base * (0.72 + weight * 0.48), 0.22);
  }
}
